function shuffleGrid(grid) {
  const items = Array.from(grid.children);
  if (items.length < 2) return;

  for (let i = items.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [items[i], items[j]] = [items[j], items[i]];
  }

  items.forEach(item => grid.appendChild(item));
}

function initRandomProducts() {
  const grids = document.querySelectorAll(
    ".product-grid, .collection__products, .grid"
  );

  grids.forEach(grid => {
    if (!grid.dataset.randomized) {
      shuffleGrid(grid);
      grid.dataset.randomized = "true";
    }
  });
}

// Run at load
document.addEventListener("DOMContentLoaded", initRandomProducts);

// Observe dynamic loads (HOME)
const observer = new MutationObserver(() => {
  initRandomProducts();
});

observer.observe(document.body, {
  childList: true,
  subtree: true
});
